module.exports = __webpack_public_path__ + "img/full5-min.7c7b6db4.png";